import { useTranslation,  } from 'react-i18next'
import { useMemo } from 'react'
import { preFixImgUrl } from '@/utils'
export default () => {
  const { t } = useTranslation();

  const services = useMemo(() => [
    {
      titleKey: "2face859",
      img: preFixImgUrl('ce814c846f9e5988adce4405a60614d6.png'),
    },
    {
      titleKey: "4594d408",
      img: preFixImgUrl('1ab902c92e2c037ae6b8b14bf329223c.png'),
    },
    {
      titleKey: "dffd8c67",
      img: preFixImgUrl('17e3d72cd013bf517cf2485ad6275121.png'),
    },
    {
      titleKey: "b473ec84",
      img: preFixImgUrl('5206e9cf5f56a292424f14c2e0a02eac.png'),
    },
  ], [t])

  const brands = useMemo(() => [
    {
      img: preFixImgUrl('4edeb31c59870afcf33e9fbf2fd3aedb.png'),
    },
    {
      img: preFixImgUrl('752fb87c97d8872dbe413c2629e942d8.png'),
    },
    {
      img: preFixImgUrl('f7b927ce50d7ebf0e1b17cfc7080ad90.png'),
    },
    {
      img: preFixImgUrl('55b6f53ff70e6b12bd3728b8aeac61a8.png'),
    },
    {
      img: preFixImgUrl('93c37f94c357edd171daf02803f15b44.png'),
    },
    {
      img: preFixImgUrl('10500619f05caf47ed0d0076a122dc65.png'),
    },
    {
      img: preFixImgUrl('6b54262b545193b7a7fb65d9f47dcb49.png'),
    },
    {
      img: preFixImgUrl('15a9e9beb780b234b25914614c55e38a.png'),
    },
    {
      img: preFixImgUrl('bd6b9b021427303c237a51a3fe60e9ea.png'),
    },
    {
      img: preFixImgUrl('26407b33597827a850022f6383424643.png'),
    },
    {
      img: preFixImgUrl('3b2ee1f82535344da99641b33ef7b11d.png'),
    },
    {
      img: preFixImgUrl('216de9818a91fb6d5bbd2e4ed8277549.png'),
    },
    {
      img: preFixImgUrl('8d5c4a742440d95c585c2e9d34c1a7b9.png'),
    },
    {
      img: preFixImgUrl('d7fa9b776fb06819e87b506c3c5bff06.png'),
    },
    {
      img: preFixImgUrl('37f51d8bafe60b058574f4592b7aa2cd.png'),
    },
  ], [])

  return {
    brands,
    services,
  }
}